import Swiper, { Navigation, Pagination } from 'swiper';

class Carousel {
  constructor(carousel) {
    this.carousel = carousel;
    this.id = this.carousel.id;

    Swiper.use([Navigation, Pagination]);
    this.carousel = new Swiper(`.carousel__container${this.id}`, {
      loop: carousel.dataset.carouselLoop,
      spaceBetween: 24,
      slidesPerView: 1,
      containerModifierClass: 'carousel--',
      wrapperClass: 'carousel__wrapper',
      slideClass: 'carousel__item',

      navigation: {
        nextEl: `.carousel__navigation--next${this.id}`,
        prevEl: `.carousel__navigation--prev${this.id}`,
        disabledClass: 'carousel__navigation--disabled',
      },

      pagination: {
        el: `.carousel__pagination${this.id}`,
        clickable: true,
        modifierClass: 'carousel__pagination--',
        bulletClass: 'carousel__bullet',
        bulletActiveClass: 'carousel__bullet--active',
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: carousel.dataset.carouselColumns,
        },
      },
    });
  }
}

const init = () => {
  [...document.querySelectorAll('.js-carousel')].forEach((el) => new Carousel(el));
};

export { init };
